"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    avatar: {
      width: 96,
      height: 96,
      border: "2px solid ".concat(palette.grey.timberWolf),
      background: 'white'
    },
    avatarSelected: {
      border: "2px solid ".concat(palette.green.fruitSalad)
    },
    disabled: {
      opacity: 0.5
    }
  };
});

var InvitationTypeAvatar = function InvitationTypeAvatar(_ref2) {
  var selected = _ref2.selected,
      image = _ref2.image,
      disabled = _ref2.disabled;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: (0, _classnames.default)(classes.avatar, {
      [classes.avatarSelected]: selected,
      [classes.disabled]: disabled
    }),
    src: image,
    color: selected ? 'primary' : 'secondary'
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(InvitationTypeAvatar);

exports.default = _default;